import React from "react";
import { faqs } from "../data/home";
import { usePageMeta } from "../hooks/usePageMeta";
import { HomeHero } from "../components/home/HomeHero";
import { TrustMarquee } from "../components/home/TrustMarquee";
import { HowBailWorks } from "../components/home/HowBailWorks";
import { WhyDifferent } from "../components/home/WhyDifferent";
import { BondToolsSection } from "../components/home/BondToolsSection";
import { CalculatorSection } from "../components/home/CalculatorSection";
import { MeetVictor } from "../components/home/MeetVictor";
import { BondTypesGrid } from "../components/home/BondTypesGrid";
import { Testimonials } from "../components/home/Testimonials";
import { ResourcesTeaser } from "../components/home/ResourcesTeaser";
import { FaqSection } from "../components/home/FaqSection";
import { FinalCtaBand } from "../components/FinalCtaBand";
export function Home() {
  usePageMeta({
    title: "Las Vegas Bail Bonds 24/7 | Quick, Courteous, Private | Post Bail Bonds Inc.",
    description: "Locally owned, veteran-owned Las Vegas bail bonds since 2011. Free consultations, free rides home from jail, payment plans, 100% confidential. Call 702-384-7777 — open 24/7.",
    jsonLd: [{
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map(f => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: {
          "@type": "Answer",
          text: f.a
        }
      }))
    }, {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [{
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://www.postvegasbond.com/"
      }]
    }]
  });
  return <>
      <HomeHero data-id="element-440" data-mp="239ssg5pjcphn" />
      <TrustMarquee data-id="element-441" data-mp="23ac5p948qppc" />
      <HowBailWorks data-id="element-442" data-mp="236y4w5b86ok0" />
      <WhyDifferent data-id="element-443" data-mp="1z7fvo6sro1x0" />
      <BondToolsSection data-id="element-444" data-mp="1z7xosuk4u00p" />
      <CalculatorSection data-id="element-445" data-mp="1z64i5f9irfsp" />
      <MeetVictor data-id="element-446" data-mp="1z9ik4me9tmzm" />
      <BondTypesGrid data-id="element-447" data-mp="1u8cpgj11vpng" />
      <Testimonials data-id="element-448" data-mp="1u7t9h7uynbc2" />
      <ResourcesTeaser data-id="element-449" data-mp="1u9e5l1wxb2c1" />
      <FaqSection data-id="element-450" data-mp="1u94l1tundndq" />
      <FinalCtaBand data-id="element-451" data-mp="1uap7sxaq0211" />
    </>;
}